import lodash from 'lodash';

const state = () => ({
  attachments: [],
  isInvalid: false
});

const getters = {
  attachments(state) {
    return state.attachments;
  },
  isInvalid(state) {
    return state.isInvalid;
  }
};

const mutations = {
  addAttachment(state, payload) {
    state.attachments.push(payload);
  },
  deleteAttachment(state, payload) {
    state.attachments = lodash.cloneDeep(state.attachments).filter(att => {
      if (payload.id) {
        return att.id !== payload.id;
      }

      return att.uuid !== payload.uuid;
    });
  },
  resetAttachments(state) {
    state.attachments = [];
  },
  setAttachments(state, payload) {
    state.attachments = payload;
  },
  setIsInvalid(state, payload) {
    state.isInvalid = payload;
  },
  resetStore(storeState) {
    Object.assign(storeState, state());
  }
};

export const attachments = {
  state,
  getters,
  mutations,
  namespaced: true
};
